import gql from 'graphql-tag';

export const addUzivatel = gql`
    mutation addUzivatel($input: [UzivatelInput!]!){
      response: addUzivatel(inputUzivatel: $input){
        id
      }
    }
`;
